( function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller( 'CommentAuditDialogController', CommentAuditDialogController );

    CommentAuditDialogController.$inject = [ 'entity', '$stateParams', '$uibModalInstance', 'CommentCustomService', 'ToastrService' ];

    function CommentAuditDialogController( entity, $stateParams, $uibModalInstance, CommentCustomService, ToastrService ) {
        var vm = this;

        vm.entity = entity;
        // vm.audits = commentAudits;
        vm.audits = [];
        CommentCustomService.returnCommentAuditById( entity.id ).then( function( data ) {
            vm.audits = data.data;
        }, function() {
            ToastrService.error( "Failed to get Comment Audits", "Error!" );
        });

        vm.close = close;

        function close() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
